/* Foreli - Popup nativo de cupom + integração direta com RD Station */
(function () {
  'use strict';

  // ---- Configuração da integração com a RD Station ----
  var RD_API_TOKEN = '03be59036ca6f825a3a20950e8497fd1';
  var RD_CONVERSION_IDENTIFIER = 'popup-cupom-10off';
  var RD_CONVERSION_URL = 'https://api.rd.services/platform/conversions?api_key=' + RD_API_TOKEN;

  var COOKIE_NAME = 'foreli_popup_dismissed';
  var SESSION_KEY = 'foreli_popup_shown_session';
  var COOKIE_DAYS = 365;

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function sessionAlreadyShown() {
    try { return sessionStorage.getItem(SESSION_KEY) === '1'; } catch (e) { return false; }
  }
  function markSessionShown() {
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
  }
  function isPermanentlyDismissed() {
    return getCookie(COOKIE_NAME) === '1';
  }
  function dismissPermanently() {
    setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
  }

  // Envia o lead direto pra RD Station via API — não depende de o
  // robô da RD "achar" o formulário na tela, então funciona mesmo
  // com o captcha/iframe de segurança da Shopify no meio do caminho.
  function sendToRD(email) {
    try {
      fetch(RD_CONVERSION_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          event_type: 'CONVERSION',
          event_family: 'CDP',
          payload: {
            conversion_identifier: RD_CONVERSION_IDENTIFIER,
            email: email
          }
        })
      }).catch(function (err) {
        console.warn('[Foreli popup] Falha ao enviar lead para a RD Station:', err);
      });
    } catch (e) {
      console.warn('[Foreli popup] Erro ao montar envio para a RD Station:', e);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var overlay = document.getElementById('foreli-popup-overlay');
    if (!overlay) return;

    var stepForm = overlay.querySelector('[data-foreli-popup-step="form"]');
    var stepSuccess = overlay.querySelector('[data-foreli-popup-step="success"]');
    var form = document.getElementById('foreli-popup-form');
    var emailInput = overlay.querySelector('[data-foreli-popup-email-input]');
    var hiddenEmailInput = overlay.querySelector('[data-foreli-popup-hidden-email]');
    var submitBtn = overlay.querySelector('[data-foreli-popup-submit]');
    var errorEl = overlay.querySelector('[data-foreli-popup-error]');
    var iframeTarget = document.getElementsByName('foreli-popup-target')[0];

    function warmUpSpamProtection() {
      if (!form) return;
      try {
        form.dispatchEvent(new Event('focusin', { bubbles: true }));
        form.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e) {}
    }

    function showPopup() {
      overlay.classList.add('is-visible');
      overlay.setAttribute('aria-hidden', 'false');
      markSessionShown();
      warmUpSpamProtection();
    }
    function hidePopup() {
      overlay.classList.remove('is-visible');
      overlay.setAttribute('aria-hidden', 'true');
    }
    function goToSuccessStep() {
      if (stepForm) stepForm.hidden = true;
      if (stepSuccess) stepSuccess.hidden = false;
    }

    overlay.addEventListener('click', function (evt) {
      if (evt.target.closest('[data-foreli-popup-close]')) {
        evt.preventDefault();
        hidePopup();
      }
    });

    overlay.addEventListener('click', function (evt) {
      if (evt.target.closest('[data-foreli-popup-decline]')) {
        evt.preventDefault();
        dismissPermanently();
        hidePopup();
      }
    });

    if (emailInput && hiddenEmailInput) {
      emailInput.addEventListener('input', function () {
        hiddenEmailInput.value = emailInput.value;
      });
      emailInput.addEventListener('focus', warmUpSpamProtection);
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    }
    function clearError() {
      if (!errorEl) return;
      errorEl.hidden = true;
      errorEl.textContent = '';
    }
    function setLoading(isLoading) {
      if (!submitBtn) return;
      submitBtn.disabled = isLoading;
      var spinner = submitBtn.querySelector('.foreli-popup__btn-spinner');
      if (spinner) spinner.hidden = !isLoading;
    }

    if (form) {
      var submissionTimeout = null;
      var waitingResponse = false;

      form.addEventListener('submit', function (evt) {
        clearError();

        if (!emailInput || !emailInput.value || !emailInput.validity.valid) {
          evt.preventDefault();
          showError('Digite um e-mail válido.');
          if (emailInput) emailInput.focus();
          return;
        }

        if (hiddenEmailInput) hiddenEmailInput.value = emailInput.value;
        setLoading(true);
        waitingResponse = true;

        // Envia pra RD Station imediatamente, em paralelo — não depende
        // do resultado do cadastro na Shopify.
        sendToRD(emailInput.value);

        if (submissionTimeout) clearTimeout(submissionTimeout);
        submissionTimeout = setTimeout(function () {
          if (!waitingResponse) return;
          waitingResponse = false;
          setLoading(false);
          showError('Isso está demorando mais que o normal. Tente novamente em instantes.');
        }, 20000);
      });

      if (iframeTarget) {
        iframeTarget.addEventListener('load', function () {
          if (!waitingResponse) return;
          waitingResponse = false;
          if (submissionTimeout) clearTimeout(submissionTimeout);
          setLoading(false);
          dismissPermanently();
          goToSuccessStep();
        });
      }
    }

    // ---- Regras de exibição ----
    if (isPermanentlyDismissed()) return;
    if (sessionAlreadyShown()) return;

    var triggered = false;
    function triggerOnce() {
      if (triggered) return;
      triggered = true;
      window.removeEventListener('scroll', triggerOnce);
      document.removeEventListener('click', clickTrigger, true);
      showPopup();
    }
    function clickTrigger(evt) {
      if (overlay.contains(evt.target)) return;
      if (evt.target.closest('a, button')) {
        triggerOnce();
      }
    }

    window.addEventListener('scroll', triggerOnce, { passive: true, once: true });
    document.addEventListener('click', clickTrigger, true);
  });
})();